import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

import { Paper } from '@/shared/components/ui/paper/paper.styled';
import { rowStyle } from '@/shared/components/ui/shared-styles/shared-styles.styled';
import { TRowStyleProps } from '@/shared/components/ui/shared-styles/shared-styles.types';

export const StyledCard = styled(Paper)`
  && {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    box-shadow: none;
    border-radius: ${({ theme }) => theme.shape.cardRadius};
    min-height: 20rem;
    min-width: 20vw;
    overflow: hidden;
  }
`;

export const CardHeader = styled(Box)`
  && {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing(2)};
    padding-bottom: ${({ theme }) => theme.spacing(2)};
    position: relative;
    padding: ${({ theme }) => `0 ${theme.spacing(5)}`};
    height: 5rem;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: ${({ theme }) => theme.palette.divider};
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    & > svg {
      color: ${({ theme }) => theme.palette.text.secondary};
      transition: color 0.2s ease;
    }

    &:hover {
      &:after {
        opacity: 1;
      }

      & > svg {
        color: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }
`;

export const Title = styled(Typography)`
  && {
    flex: 1;
  }
`;

export const CardRows = styled(Box)`
  && {
    border-radius: ${({ theme }) =>
      `0 0 ${theme.shape.cardRadius} ${theme.shape.cardRadius}`};
  }
`;

export const CardRow = styled(Box)<TRowStyleProps>`
  && {
    ${rowStyle};
    cursor: pointer;
    padding: 1rem 1.25rem;

    &:after {
      left: 1.25rem;
      right: 1.25rem;
    }
  }
`;
